import { validateRegistrationForm, formatRegistrationErrors } from '../utils/registration_helpers'

export default class RegisterBidController {
  constructor(element) {
    this.element = element
    this.publicKey = element.dataset.registerBidPublicKeyValue
    this.submitUrl = element.dataset.registerBidSubmitUrlValue
    this.hasCard = element.dataset.registerBidHasCardValue === 'true'
    this.brickController = null
    this.modal = null

    this.element.addEventListener('click', (e) => {
      e.preventDefault()
      this.openModal()
    })
  }

  openModal() {
    if (this.modal) return

    this.modal = document.createElement('div')
    this.modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.75);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;'

    this.modal.innerHTML = `
      <div class="register-bid-modal" style="background:white;border-radius:12px;max-width:32rem;width:100%;max-height:90vh;overflow-y:auto;position:relative;padding:2rem;">
        <button class="register-bid-modal__close" style="position:absolute;top:1rem;right:1rem;background:none;border:none;cursor:pointer;padding:0.25rem;" aria-label="Cerrar">
          <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div style="text-align:center;margin-bottom:1.5rem;">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="margin:0 auto 0.75rem;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
          </svg>
          <h2 style="font-size:1.5rem;font-weight:700;margin:0 0 0.5rem;">${this.hasCard ? 'Completa tu registro' : 'Registrarse para ofertar'}</h2>
          <p style="color:#65676B;font-size:0.875rem;line-height:1.5;margin:0;">
            ${this.hasCard
              ? 'Ya tenes una tarjeta registrada. Solo falta completar tu cedula y telefono para poder ofertar.'
              : 'Requerimos una tarjeta de credito valida para ofertar. Los ganadores pagan una comision del 5% sobre el monto final. La comision minima es USD 250 y la maxima USD 7,500. Las ofertas son vinculantes, oferta con responsabilidad!'}
          </p>
        </div>

        <div id="register-bid-card-section" style="margin-bottom:1rem;${this.hasCard ? 'display:none;' : ''}">
          <h3 style="font-size:0.875rem;font-weight:600;margin:0 0 0.75rem;color:#050505;">Informacion de Tarjeta de Credito</h3>
          <div id="registerBidBrick_container"></div>
        </div>

        <div style="margin-bottom:1.5rem;">
          <h3 style="font-size:0.875rem;font-weight:600;margin:0 0 0.75rem;color:#050505;">Informacion de Contacto</h3>
          <div style="display:flex;flex-direction:column;gap:0.75rem;">
            <div>
              <label for="register-bid-phone" style="display:block;font-size:0.8125rem;font-weight:500;margin-bottom:0.25rem;color:#050505;">Telefono</label>
              <input type="tel" id="register-bid-phone" placeholder="099 123 456" style="width:100%;padding:0.625rem 0.75rem;border:1px solid #DADDE1;border-radius:6px;font-size:0.875rem;box-sizing:border-box;" />
            </div>
            <div>
              <label for="register-bid-cedula" style="display:block;font-size:0.8125rem;font-weight:500;margin-bottom:0.25rem;color:#050505;">Cedula</label>
              <input type="text" id="register-bid-cedula" placeholder="12345678" style="width:100%;padding:0.625rem 0.75rem;border:1px solid #DADDE1;border-radius:6px;font-size:0.875rem;box-sizing:border-box;" />
            </div>
          </div>
        </div>

        <p style="font-size:0.75rem;color:#8A8D91;margin:0 0 1rem;line-height:1.4;${this.hasCard ? 'display:none;' : ''}">
          Para verificacion, realizamos una pre-autorizacion temporal de $1 en tu tarjeta para confirmar tu metodo de pago.
        </p>

        <button id="register-bid-submit" class="btn-primary" style="width:100%;padding:0.75rem;font-size:1rem;cursor:pointer;">
          ${this.hasCard ? 'Completar registro' : 'Registrarse para ofertar'}
        </button>

        <div id="register-bid-errors" style="display:none;margin-top:0.75rem;padding:0.75rem;background:#FEF2F2;border:1px solid #FECACA;border-radius:6px;color:#DC2626;font-size:0.875rem;"></div>
      </div>
    `

    document.body.appendChild(this.modal)
    document.body.style.overflow = 'hidden'

    // Bind close handlers
    this.modal.querySelector('.register-bid-modal__close').addEventListener('click', () => this.closeModal())
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal()
    })
    this._escHandler = (e) => { if (e.key === 'Escape') this.closeModal() }
    document.addEventListener('keydown', this._escHandler)

    // Bind submit
    this.modal.querySelector('#register-bid-submit').addEventListener('click', () => this.handleSubmit())

    // Initialize MercadoPago Brick (skip if user already has a card)
    if (!this.hasCard) {
      this.initBrick()
    }
  }

  async initBrick() {
    if (!window.MercadoPago) {
      console.error("MercadoPago SDK not loaded")
      return
    }

    this.mp = new window.MercadoPago(this.publicKey, { locale: "es-UY" })
    const bricksBuilder = this.mp.bricks()

    try {
      this.brickController = await bricksBuilder.create("cardPayment", "registerBidBrick_container", {
        initialization: {
          amount: 1
        },
        customization: {
          visual: {
            style: {
              theme: "default"
            },
            hideFormTitle: true
          },
          paymentMethods: {
            maxInstallments: 1
          }
        },
        callbacks: {
          onReady: () => {
            // Hide the Brick's internal submit button
            const style = document.createElement('style')
            style.textContent = '#registerBidBrick_container form > div:last-child { display: none !important; }'
            document.head.appendChild(style)
            this._brickStyle = style
          },
          onSubmit: () => {
            // We handle submission ourselves via getFormData
          },
          onError: (error) => {
            console.error("MercadoPago Brick error:", error)
          }
        }
      })
    } catch (error) {
      console.error("Error creating CardPayment Brick:", error)
    }
  }

  async handleSubmit() {
    const phoneInput = this.modal.querySelector('#register-bid-phone')
    const cedulaInput = this.modal.querySelector('#register-bid-cedula')
    const errorDiv = this.modal.querySelector('#register-bid-errors')
    const submitBtn = this.modal.querySelector('#register-bid-submit')

    errorDiv.style.display = 'none'

    // Client-side validation
    const phone = phoneInput.value.trim()
    const cedula = cedulaInput.value.trim()
    const clientErrors = validateRegistrationForm({ phone, cedula })

    if (clientErrors.length > 0) {
      errorDiv.textContent = formatRegistrationErrors(clientErrors)
      errorDiv.style.display = 'block'
      return
    }

    submitBtn.disabled = true
    submitBtn.textContent = 'Procesando...'

    const defaultBtnText = this.hasCard ? 'Completar registro' : 'Registrarse para ofertar'

    try {
      let cardToken = null

      if (this.hasCard) {
        // User already has a card, just need cedula/phone
        // Submit to card_verification update endpoint
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
        const response = await fetch('/card_verification', {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': csrfToken
          },
          body: JSON.stringify({
            national_id: cedula,
            phone_number: phone
          })
        })

        const data = await response.json()

        if (data.success) {
          window.location.reload()
        } else {
          errorDiv.textContent = data.error || 'Error desconocido.'
          errorDiv.style.display = 'block'
          submitBtn.disabled = false
          submitBtn.textContent = defaultBtnText
        }
        return
      }

      if (!this.brickController) {
        errorDiv.textContent = 'El formulario de tarjeta aun no esta listo. Intenta de nuevo.'
        errorDiv.style.display = 'block'
        submitBtn.disabled = false
        submitBtn.textContent = defaultBtnText
        return
      }

      // Trigger Brick validation and get form data with token
      const cardFormData = await this.brickController.getFormData()

      if (!cardFormData || !cardFormData.token) {
        errorDiv.textContent = 'Completa la informacion de la tarjeta correctamente.'
        errorDiv.style.display = 'block'
        submitBtn.disabled = false
        submitBtn.textContent = defaultBtnText
        return
      }

      // POST to bid_registration endpoint
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(this.submitUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          card_token: cardFormData.token,
          national_id: cedula,
          phone_number: phone
        })
      })

      const data = await response.json()

      if (data.success) {
        window.location.reload()
      } else {
        errorDiv.textContent = (data.errors || ['Error desconocido.']).join(' ')
        errorDiv.style.display = 'block'
        submitBtn.disabled = false
        submitBtn.textContent = defaultBtnText
      }
    } catch (err) {
      console.error("Registration error:", err)
      errorDiv.textContent = 'Error de conexion. Intenta de nuevo.'
      errorDiv.style.display = 'block'
      submitBtn.disabled = false
      submitBtn.textContent = defaultBtnText
    }
  }

  closeModal() {
    if (!this.modal) return

    if (this.brickController && typeof this.brickController.unmount === 'function') {
      try { this.brickController.unmount() } catch (e) { /* ignore */ }
    }
    if (this._brickStyle) {
      this._brickStyle.remove()
    }

    document.removeEventListener('keydown', this._escHandler)
    document.body.style.overflow = ''
    this.modal.remove()
    this.modal = null
    this.brickController = null
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-controller="register-bid"]').forEach(el => {
    new RegisterBidController(el)
  })
})
